export class CommValueType {
    WageType: string = "0";
    Value: number=0;
    CostVal: number = 0;
    ServiceVal: number = 0;
}